import React, { useEffect, useState, useContext } from "react";
import Section from "../../UIcomponent/Section";
import MiniWeekly from "../../Component/MiniWeekly/MiniWeekly";
import StyledButton from "../../UIcomponent/Button";
import Text from "../../UIcomponent/Text";
import TeacherDic from "./TeacherDic";
import TeacherProfileReq from "../../Utility/Requester/TeacherProfileReq";
import DateTime from "../../Utility/Method/DateTime";
import BookingReq from "../../Utility/Requester/BookingReq";
import { TodayObj } from "../../Utility/TodayObj";
import moment from "moment-jalaali";
import BookingContext from "../../Context/BookingContext";
import Col from "../../UIcomponent/Column";
const MiniWeeklySchedule = (props) => {
  const { lang } = props;
  const { available, onClick, ID, loading, setLoading, disable } = props;
  let BookingCtxt = useContext(BookingContext);
  const WeekDateTimeObj = (firstDay, mode) => {
    if (mode == "next") {
      return {
        dateTimeFrom: moment(
          new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)
        ).toISOString(),
        dateTimeTo: moment(
          new Date(firstDay.Year, firstDay.Month, firstDay.Day + 7, 0, 0, 0)
        ).toISOString(),
      };
    } else if (mode == "previous") {
      return {
        dateTimeFrom: moment(
          new Date(firstDay.Year, firstDay.Month, firstDay.Day, 0, 0, 0)
        ).toISOString(),
        dateTimeTo: moment(
          new Date(firstDay.Year, firstDay.Month, firstDay.Day + 7, 0, 0, 0)
        ).toISOString(),
      };
    } else {
      return null;
    }
  };

  const GetAvailabilty = (firstDay, mode, callBack) => {
    let params = {
      timeZone: DateTime.timeZone(),
      dateTimeFrom: WeekDateTimeObj(firstDay, mode).dateTimeFrom,
      dateTimeTo: WeekDateTimeObj(firstDay, mode).dateTimeTo,
    };
    if (callBack) {
      callBack();
    }
    BookingReq.getAvailability(ID, params)
      .then((res) => {
        let Result = [...BookingCtxt.DateStatus];
        res.data.forEach((each) => {
          return Result.push({
            status: 1,
            date_time_from: each.from,
            date_time_to: each.to,
          });
        });

        // BookingCtxt.setDateStatus(Result)
        setLoading(false);
      })
      .catch((err) => {});
  };
  const Click = () => {
    onClick();
    GetAvailabilty(TodayObj(0), "next");
  };
  return (
    // available &&
    <Section className={props.className}>
      <Col
        xl={21}
        lg={21}
        md={21}
        sm={21}
        xs={21}
        loading={available ? false : true}
        style={{
          height: 24 * (6 + 1) + "px",
          // overflow: MiniWeekly ? 'hidden' : calendar ? 'auto' : 'hidden'
        }}
      >
        {available && (
          <MiniWeekly
            duration={4}
            lang={lang}
            size={24}
            available={available}
          />
        )}
      </Col>
      {/* <StyledButton
        onClick={Click}
        className="o__Teacher__Side__Schedule__Review__Button"
      >
        {TeacherDic.DayTimeReview[`${lang}`]}
      </StyledButton> */}
      {/* {available ? (
        <></>
      ) : (
        <Col
          xl={21}
          lg={21}
          md={21}
          sm={21}
          xs={21}
          loading={available ? false : true}
          style={{
            height: 50,
            // width: '%',
          }}
        ></Col>
      )} */}
      {available && (
        <Text className="o__Teacher__Side__Schedule__Notif">
          {TeacherDic.allTimeIsLocalize[`${lang}`]}
        </Text>
      )}
    </Section>
  );
};

export default MiniWeeklySchedule;
